import styled, { css } from 'styled-components/macro'
import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const Container = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  background: radial-gradient(
    50% 50% at 50% 50%,
    ${theme.colors.accent.secondaryLight},
    ${theme.colors.accent.secondary}
  );

  ${mq.ltLarge} {
    flex-direction: column;
  }

  ${mq.large} {
    height: 100vh;
  }
`

export const ListContainer = styled.div`
  display: contents;

  ${mq.large} {
    display: block;
  }
`

export const Title = styled.h2`
  position: relative;
  margin: 0;
  padding: 5rem 4rem 0;
  font-weight: 700;
  font-size: 2.8rem;
  color: white;
  width: 0;
  white-space: nowrap;
  z-index: 1;

  ${mq.medium} {
    font-size: 3.4rem;
  }

  ${mq.large} {
    font-size: 4.8rem;
  }

  ${mq.ltLarge} {
    text-align: center;
    width: auto;
  }
`

export const List = styled.ul`
  padding: 4rem 0 4rem 4rem;
  margin: 0;
  list-style: none;
  color: white;

  ${mq.ltLarge} {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(8em, 1fr));
    gap: 0 1rem;
    width: 100%;
    padding: var(--container-spacing);
    z-index: 10;
  }

  ${mq.large} {
    position: sticky;
    top: 0;
  }
`

export const ListItem = styled.li<{ $isActive: boolean }>`
  position: relative;
  display: flex;
  border-top: 1px solid #ffffff33;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: calc(100% + 4rem);
    height: 100%;
    transform: scaleX(0);
    transform-origin: 0 0;
    transition: all 0.4s ${theme.ease.in};
    background-color: ${theme.colors.accent.primary};
    z-index: -1;
  }

  ${props =>
    props.$isActive &&
    css`
      &::before {
        transform: scaleX(1);
        transition-timing-function: ${theme.ease.out};
      }
    `}

  ${mq.ltLarge} {
    &::before {
      width: calc(100% + 2rem);
    }
  }

  ${mq.large} {
    &:first-child {
      border-top: 0;
    }
  }

  button {
    ${styleReset}
    flex-grow: 1;
    padding: 0.4rem 2em 0.4rem 0;
    cursor: pointer;
  }
`

export const MapContainer = styled.div<{ $hasMask: boolean }>`
  position: relative;
  flex-grow: 1;
  height: 100vw;
  overflow: hidden;

  ${mq.large} {
    height: 100vh;

    ${props =>
      props.$hasMask &&
      css`
        mask: linear-gradient(to right, transparent, black 25%);
      `}
  }
`

export const ZoomContainer = styled.div`
  position: absolute;
  /* margin-left: 50%; */
  aspect-ratio: 1322 / 615;
  transform-origin: 0 0;
  transition: all 0.5s;

  ${mq.ltLarge} {
    width: 450%;
    inset: 0 5vmin 0 0;
  }

  ${mq.large} {
    height: 270%;
    inset: 10vmin;
  }

  img {
    display: block;
    position: absolute;
    height: 100%;
  }
`
